import React from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className="clean-footer crev">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-2">
            <div className="logo icon-img-100 md-mb80">
              <img src="/assets/imgs/logo-light.png" alt="" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Contact</h6>
              <h6 className="p-color fw-400">
                A/p - Baramati Dist - Pune,<br /> 413102
              </h6>
              <h6 className="mt-30 mb-15">
                <a href="#0">vipulnagarkar102@gmail.com</a>
              </h6>
              <a href="#0" className="underline">
                <span className="fz-22 main-color">+91 7030495391 | +91 7020976251</span>
              </a>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Useful Links</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15">
                  <a href="/home-main">Home</a>
                </li>
                <li className="mb-15">
                  <a href="/page-about">About</a>
                </li>
                <li className="mb-15">
                  <a href="/portfolio-grid">Portfolio</a>
                </li>
                <li>
                  <a href="/home-modern-studio">Services</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="column subscribe-minimal">
              <h6 className="sub-title mb-30">Newsletter</h6>
              <div className="form-group mb-40">
                <input type="text" name="subscrib" placeholder="Your Email" />
                <button>
                  <span className="ti-location-arrow"></span>
                </button>
              </div>
              <ul className="rest social-icon d-flex align-items-center">
              
                <li className="hover-this cursor-pointer ml-10">
                  <a href="https://www.behance.net/VipulNagarkar/" className="hover-anim">
                    <i className="fab fa-behance"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <Link to="https://in.linkedin.com/in/vipul-nagarkar-784468148/" className="hover-anim">
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">
              © 2024 This site is Design & Maintain by{' '}
              <span className="underline main-color">
                <a href="#" target="_blank">
                  Vipul Nagarkar
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </footer>
  );
}

export default Footer;
